declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_collide_named2_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_collide_named2 extends $bog_fragile_demo_collide_base2 {
		attach_icon( ): string
		Attach( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=named2.view.tree.d.ts.map